import axios from "@/utils/axios"
import { create } from "zustand"

type States = {
    orderLists: IObj[];
    userDetails: IObj
}
type Actions = {
    orderedLists: () => Promise<IResponse>//get request
    orderDetails: (id: string) => Promise<IResponse>
    addRatingAndReview: (doc: IRatingRequest) => Promise<IResponse>
    fetchUserProfile: () => Promise<IResponse>
    updateUserProfile: (doc: IObj) => Promise<IResponse>
    cancelOrder: (order_id: string, reason: string) => Promise<IResponse>
    returnOrder: (order_id: string, reason: string) => Promise<IResponse>

}

interface IObj {
    [key: string]: any
}
interface IRatingRequest {
    order_id: string
    uid: string,
    items: IRatingItems[]
}
interface IRatingItems {
    pdt_id: string
    pdt_nm: string
    variant_id?: string | null
    rating: number
    review: string
}
interface IResponse {
    status: boolean
    data?: any
    error?: string
    message?: string
}


const useUserOrderedStore = create<States & Actions>((set) => ({
    orderLists: [],
    userDetails: {},
    orderedLists: async () => {
        try {
            const result = await axios.post(process.env.NEXT_PUBLIC_BOOKING_SERVICE + "/user-order/list");
            if (result?.data?.status) {
                set({ orderLists: result.data?.data?.list })
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },
    orderDetails: async (id: string) => {
        try {
            const result = await axios.get(process.env.NEXT_PUBLIC_BOOKING_SERVICE + `/user-order/details?oid=${id}`);
            if (result?.data?.status) {
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },
    addRatingAndReview: async (doc: IRatingRequest) => {
        try {
            const result = await axios.post(process.env.NEXT_PUBLIC_BOOKING_SERVICE + `/rate-and-review/add`, doc);
            if (result?.data?.status) {
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },
    fetchUserProfile: async () => {
        try {
            const result = await axios.get(process.env.NEXT_PUBLIC_USER_SERVICE + `/user/details`);
            if (result?.data?.status) {
                set({ userDetails: result.data?.data })
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },

    updateUserProfile: async (doc: IObj) => {
        try {
            let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/edit-profile`, doc)
            if (result.data?.status) {
                return { status: true, data: result.data?.data, message: result.data?.message }
            } else {
                return { status: false, message: result?.data?.message, error: result?.data?.error || "" }
            }
        } catch (error: any) {
            return { status: false, message: error?.message || "Something went wrong!" }
        }
    }
    ,
    cancelOrder: async (order_id: string, reason: string) => {
        try {
            const result = await axios.post(process.env.NEXT_PUBLIC_BOOKING_SERVICE + `/order/cancellation`, { order_id: order_id, comment: reason });
            if (result?.data?.status) {
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    },
     returnOrder: async (order_id: string, reason: string) => {
        try {
            const result = await axios.post(process.env.NEXT_PUBLIC_BOOKING_SERVICE + `/order/return`, { order_id: order_id, comment: reason });
            if (result?.data?.status) {
                return { status: true, data: result.data?.data };
            } else {
                return { status: false, error: result.data?.error || "Something went wrong" };
            }
        } catch (error: any) {
            return { status: false, error: error?.message || "Something went wrong" };
        }
    }
}))
export default useUserOrderedStore
